module.exports = __webpack_public_path__ + "static/media/Mystino-home.8b0f995d.jpg";